import type { GanttFornecedorNomeProps } from "./types-gantt-fornecedor-nome";
import { useGanttFornecedorNome } from "./use-gantt-fornecedor-nome";
import { GanttFornecedorNomeView } from "./view-gantt-fornecedor-nome";

/** Nome e, abaixo dele, o selo "N Conflito". */
export function GanttFornecedorNome(props: GanttFornecedorNomeProps) {
  const vm = useGanttFornecedorNome(props);

  return <GanttFornecedorNomeView {...vm} />;
}

export type * from "./types-gantt-fornecedor-nome";
